export type CallProcessingStep =
  | 'processing'
  | 'classifying'
  | 'classified'
  | 'creating_tasks'
  | 'completed';

export function getCallProcessingLabel(step: CallProcessingStep | undefined): string | undefined {
  switch (step) {
    case 'processing':
      return 'Processing call...';
    case 'classifying':
      return 'Classifying call...';
    case 'classified':
      return 'Analyzed, creating tasks...';
    case 'creating_tasks':
      return 'Creating tasks...';
    default:
      return undefined;
  }
}

const NORMALIZE_CALL_STATUS: Record<string, CallProcessingStep> = {
  processing: 'processing',
  classifying: 'classifying',
  classified: 'classified',
  handling_payment_promise: 'classified',
  handling_dispute: 'classified',
  handling_wrong_contact: 'classified',
  handling_dunning: 'classified',
  handling_dispute_resolution: 'classified',
  generating_response: 'classified',
  creating_tasks: 'creating_tasks',
  completed: 'completed',
};

export const normalizeCallStatus = (status: string): CallProcessingStep | undefined =>
  NORMALIZE_CALL_STATUS[status];

export function resolveCallProcessingStep(
  call: { id: string; processing_status?: string },
  processingSteps?: Map<string, CallProcessingStep>,
): CallProcessingStep | undefined {
  const pusherStep = processingSteps?.get(call.id);
  if (pusherStep) return pusherStep === 'completed' ? undefined : pusherStep;
  const normalized = call.processing_status
    ? NORMALIZE_CALL_STATUS[call.processing_status]
    : undefined;
  return normalized && normalized !== 'completed' ? normalized : undefined;
}

export interface CallProcessingEvent {
  call_id: string;
  message?: string;
  organization_id: string;
  partner_id: string;
  processing_status: string;
}
